import { render, staticRenderFns } from "./SaleOrderEmailItem.vue?vue&type=template&id=55962bfb&scoped=true&"
import script from "./SaleOrderEmailItem.vue?vue&type=script&lang=js&"
export * from "./SaleOrderEmailItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderEmailItem.vue?vue&type=style&index=0&id=55962bfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55962bfb",
  null
  
)

export default component.exports